import "../Script/umdk/carousel";
import "../Script/_shared/index";
import "../Script/umdk/index";
import "../Style/umdk/index.scss";
